export default "/images/b3decec8eac49fda46579b03a8c8ee9f.avif";